(function () {
  var section = document.querySelector('[data-ghost-about]');
  if (!section) return;

  var modal = section.querySelector('[data-about-modal]');
  var modalPanel = section.querySelector('.ghost-about-page__modal-panel');
  var modalTitle = section.querySelector('[data-about-modal-title]');
  var modalBody = section.querySelector('[data-about-modal-body]');
  var modalDetail = section.querySelector('[data-about-modal-detail]');
  var modalBullets = section.querySelector('[data-about-modal-bullets]');
  var modalIcon = section.querySelector('[data-about-modal-icon]');
  var closeButtons = section.querySelectorAll('[data-about-modal-close]');
  var focus = window.GhostModalFocus;

  function openModal(trigger) {
    if (!modal) return;

    var title = trigger.getAttribute('data-modal-title') || '';
    var body = trigger.getAttribute('data-modal-body') || '';
    var detail = trigger.getAttribute('data-modal-detail') || '';
    var bullets = trigger.getAttribute('data-modal-bullets') || '';
    var icon = trigger.getAttribute('data-modal-icon') || 'shield';
    var accent = trigger.getAttribute('data-modal-accent') || '#ffd700';

    if (modalTitle) modalTitle.textContent = title;
    if (modalBody) modalBody.textContent = body;
    if (modalDetail) modalDetail.textContent = detail;

    if (modalBullets) {
      modalBullets.innerHTML = '';
      if (bullets.trim()) {
        bullets.split('||').forEach(function (item) {
          var trimmed = item.trim();
          if (!trimmed) return;
          var li = document.createElement('li');
          li.className = 'ghost-about-page__modal-bullet';
          li.innerHTML =
            '<span class="ghost-about-page__modal-bullet-icon" aria-hidden="true">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</span><span></span>';
          li.querySelector('span:last-child').textContent = trimmed;
          modalBullets.appendChild(li);
        });
        modalBullets.hidden = false;
      } else {
        modalBullets.hidden = true;
      }
    }

    if (modalIcon) {
      var iconMarkup = trigger.querySelector('[data-modal-icon-markup]');
      modalIcon.innerHTML = iconMarkup ? iconMarkup.innerHTML : '';
    }

    modal.style.setProperty('--about-modal-accent', accent);
    if (focus) focus.rememberFocus();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (focus) focus.focusInitial(modalPanel, '[data-about-modal-close]');
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (focus) focus.restoreFocus();
  }

  section.querySelectorAll('[data-about-modal-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openModal(trigger);
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (focus) focus.trapTab(event, modalPanel);
  });
})();
